// 物码查询
<template>
  <div id="containt" style="padding-left: 10px;">

    <div class="grid-height" style=" height: calc(100vh - -77px);">
      <vxe-grid align="center" :span-method="mergeRowMethod" show-overflow :stripe="true" :border="true" height="100%"
        :row-config="{ isHover: true }" ref="table-m1" v-bind="vxeOption"
        @resizable-change="$vxeTableUtil.onColumnWitchChange" @custom="$vxeTableUtil.customHandle">

        <template #form>
          <div class="clearfix screen-btns" style="margin-top: 3px;">
            <div class="fl">
              <vxe-button status="primary" class="button-sty" icon="el-icon-plus" @click="openEditDialog">导出</vxe-button>
            </div>
            <div class="fr">
              <!--									<vxe-button icon="el-icon-brush" class="button-sty" @click="resetEvent" type="text"-->
              <!--										status="primary" plain>重置</vxe-button>-->
              <vxe-button status="warning" icon="el-icon-search" class="button-sty" @click="searchEvent">搜索</vxe-button>
            </div>
          </div>
          <vxe-form ref="form" class="screen-box" title-width="92px" title-align="right" :data="requestParam"
          @submit="toFilterData" @keyup.enter.native="toFilterData" @reset="searchEvent">
            <vxe-form-item title="产品条码:" field="name">
              <template v-slot>
                <el-input v-model="searchBarcode" size="small" clearable />
              </template>
            </vxe-form-item>
            <vxe-form-item title="配件条码:" field="name">
              <template v-slot>
                <el-input v-model="searchItemName" size="small" clearable />
              </template>
            </vxe-form-item>
          </vxe-form>
        </template>
        <!-- 分页器 -->
        <template #pager>
          <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
        </template>
      </vxe-grid>
    </div>

  </div>
</template>

<script>
// import { initVxeTable } from '@/const/crud/admin/table'
import pager from '@/components/pager/index.vue'
import { initVxeTable } from '@/const/crud/admin/fakeDataTable'

export default {
  name: 'code',

  components: { pager },
  data() {
    return {
      getPageDataUrl: '/basic/basCompanyBarcode/getListPage',
      showEdit: false,
      editViewDataUpdateFlag: false,
      activeName: 'second',
      dataId: 0,
      pageSizes: [10, 20, 100],
      requestParam: {
        searchCount: false,  // 是否分页
        itemCode: "",  // 产品编码
        itemName: "",  // 产品名称
        barcode: '',  // 产品条码
        current: 1,  // 当前页面
        size: 10,  // 页面数据量
      },
      searchBarcode: '',
      searchItemCode: '',
      searchItemName: '',
      total: 0,  // 数据总数
      vxeOption: {},
      columns: [
        // { type: 'seq', width: 60, title: '序号', resizable: false, fixed: 'left' },
        {
          title: '生产信息',
          children: [
            { title: '产品条码', field: 'barcode', width: 150, },
            { title: '制造商', field: 'supplierName', width: 110, },
            { title: '产品编码', field: 'barcode', width: 150, },
            { title: '产品名称', field: 'itemName', width: 110, },
            { title: '生产批次', field: 'barcode', width: 120, },
            { title: '产线', field: 'Production', width: 110, },
          ]
        },

        {
          title: '销售信息',
          children: [
            { title: '配件码', field: 'itemBarcode', width: 100, },
            { title: '配件编码', field: 'partsCode', width: 110, },
            { title: '配件型号', field: 'Model', width: 110, },
            { title: '安装时间', field: 'instDate', width: 110, },
            { title: '供应商编码', field: 'encoding', width: 110, },
            { title: '供应商名称', field: 'supply', width: 110, },
            { title: '生产批次', field: 'batch', width: 100, },
            { title: '序列号', field: 'order', width: 110, },
            // { title: '销售区域名称', field: 'saleOrgName', width: 110, },
          ]
        },
        {
          title: '',
          children: [
            { title: '销售单号', field: 'encoding', width: 80, },
            { title: '销售商', field: 'supply', width: 80, },
            { title: '销售日期', field: 'instDate', width: 100 },
          ]
        },

        // { width: 47, fixed: 'right', title: '', sortable: false, slots: {
        //     default: ({ row }) => {
        //       return [
        //         <div>
        //           <a
        //             href="javascript:void(0);"
        //             class="a-link"
        //             onclick={() => {
        //               this.openEditDialog(row.id);
        //             }}
        //           >
        //             <el-tooltip enterable={false} effect="dark" content="查看" placement="top" popper-class="tooltip-skin">
        //               <i class="el-icon-edit" />
        //             </el-tooltip>
        //           </a>
        //         </div>
        //       ];
        //     }
        //   }
        // }
      ],
    };
  },
  watch: {
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
    activeName(newVal) {
      if (newVal === 'second' && this.editViewDataUpdateFlag) {
        this.getTableData()
      }
    }
  },
  methods: {
    toFilterData() {
            this.searchEvent();
     },
    mergeRowMethod({ row, _rowIndex, column, visibleData }) {
      const fields = ['barcode', 'supplierName', 'produceCompany', "itemName", 'Production']
      const cellValue = row[column.property]
      if (cellValue && fields.includes(column.property)) {
        const prevRow = visibleData[_rowIndex - 1]
        let nextRow = visibleData[_rowIndex + 1]
        if (prevRow && prevRow[column.property] === cellValue) {
          return { rowspan: 0, colspan: 0 }
        } else {
          let countRowspan = 1
          while (nextRow && nextRow[column.property] === cellValue) {
            nextRow = visibleData[++countRowspan + _rowIndex]
          }
          if (countRowspan > 1) {
            return { rowspan: countRowspan, colspan: 1 }
          }
        }
      }
    },
    // 刷新
    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },

    // 加载table数据
    getTableData() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        path: this.getPageDataUrl,
        param: this.requestParam,
        method: 'post',
        fakeData: {
          total: 0,
          list: [
            { id: 1, barcode: '121219985689635', partsCode: 'CH958475214', partsName: '塑料管', supplierCode: 'GY2013698574', supplierName: '洲明', instDate: '2023-01-01', itemBarcode: 'CL-969696', itemCode: 'CL-969696', itemName: '空调', produceCompany: '京东', Production: 'A号线', Model: 'HD-9547', encoding: 'BM-5214', supply: '帝斯曼', batch: 'PC-1234', order: '0011001', },
            { id: 2, barcode: '121219985689635', partsCode: 'CH958475569', partsName: '灯泡', supplierCode: 'GY2013698555', supplierName: '洲明', instDate: '2023-01-18', itemBarcode: 'CL-954755', itemCode: 'CL-969696', itemName: '空调', produceCompany: '宁德时代', Production: 'A号线', Model: 'HD-9547', encoding: 'BM-5214', supply: '华力兴', batch: 'PC-6589', order: '0011002', },
            { id: 3, barcode: '121219985689635', partsCode: 'CH958475214', partsName: 'LED屏', supplierCode: 'GY2013698574', supplierName: '洲明', instDate: '2023-01-01', itemBarcode: 'CL-000000', itemCode: 'CL-969696', itemName: '空调', produceCompany: '宁德时代', Production: 'A号线', Model: 'HD-9547', encoding: 'BM-5214', supply: '帝斯曼', batch: 'PC-1234', order: '0011003', },
            { id: 4, barcode: '121219985699999', partsCode: 'CH958475569', partsName: '触控板', supplierCode: 'GY2013698555', supplierName: '华帝', instDate: '2023-01-18', itemBarcode: 'CL-111111', itemCode: 'CL-969696', itemName: '节能灯', produceCompany: '京东方', Production: 'B号线', Model: 'HD-9547', encoding: 'BM-5214', supply: '华力兴', batch: 'PC-1234', order: '0011004', },
            { id: 5, barcode: '121219985689666', partsCode: 'CH958475214', partsName: '三脚架', supplierCode: 'GY2013698574', supplierName: '洲明', instDate: '2023-01-01', itemBarcode: 'CL-222222', itemCode: 'CL-969696', itemName: '空调', produceCompany: '宁德时代', Production: 'c号线', Model: 'HD-9547', encoding: 'BM-5214', supply: '帝斯曼', batch: 'PC-1234', order: '0011005', },
            { id: 6, barcode: '121219985689666', partsCode: 'CH958475569', partsName: '过滤网', supplierCode: 'GY2013698555', supplierName: '洲明', instDate: '2023-01-18', itemBarcode: 'CL-333333', itemCode: 'CL-969696', itemName: '空调', produceCompany: '京东方', Production: 'c号线', Model: 'HD-9547', encoding: 'BM-5214', supply: '华力兴', batch: 'PC-6589', order: '0011006', },
            { id: 7, barcode: '121219985689666', partsCode: 'CH958475214', partsName: '进水管', supplierCode: 'GY2013698574', supplierName: '洲明', instDate: '2023-01-01', itemBarcode: 'CL-444444', itemCode: 'CL-969696', itemName: '空调', produceCompany: '宁德时代', Production: 'c号线', Model: 'HD-9547', encoding: 'BM-5214', supply: '华力兴', batch: 'PC-1234', order: '0011007', },
            { id: 8, barcode: '121219985688888', partsCode: 'CH958475569', partsName: '扇叶', supplierCode: 'GY2013698555', supplierName: '华帝', instDate: '2023-01-18', itemBarcode: 'CL-555555', itemCode: 'CL-969696', itemName: '节能灯', produceCompany: '京东方', Production: 'd号线', Model: 'HD-9547', encoding: 'BM-5214', supply: '帝斯曼', batch: 'PC-6589', order: '0011008', },
            { id: 9, barcode: '121219985689677', partsCode: 'CH958475214', partsName: '进水管', supplierCode: 'GY2013698574', supplierName: '洲明', instDate: '2023-01-01', itemBarcode: 'CL-666666', itemCode: 'CL-969696', itemName: '空调', produceCompany: '宁德时代', Production: 'E号线', Model: 'HD-9547', encoding: 'BM-5214', supply: '华力兴', batch: 'PC-1234', order: '0011001', },
            { id: 10, barcode:'121219985689677', partsCode: 'CH958475569', partsName: '扇叶', supplierCode: 'GY2013698555', supplierName: '华帝', instDate: '2023-01-18', itemBarcode: 'CL-777777', itemCode: 'CL-969696', itemName: '空调', produceCompany: '京东方', Production: 'E号线', Model: 'HD-9547', encoding: 'BM-5214', supply: '帝斯曼', batch: 'PC-6589', order: '0011001', },
          ]
        },
        columns: this.columns
      };
      this.vxeOption = initVxeTable(tableOption);
      this.editViewDataUpdateFlag = false;
      this.flushed()
    },

    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.getTableData()
    },

    // 搜索
    searchEvent() {
      this.requestParam.barcode = this.searchBarcode
      this.requestParam.itemName = this.searchItemName
      this.requestParam.itemCode = this.searchItemCode
      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },

    // 重置
    resetEvent() {
      this.searchBarcode = ''
      this.searchItemName = ''
      this.searchItemCode = ''
      this.requestParam.searchCount = false
      this.requestParam.barcode = ''
      this.requestParam.itemCode = ''
      this.requestParam.itemName = ''
      this.requestParam.current = 1
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },

    // 新增
    openEditDialog(id) {
      console.log(id)
      this.dataId = !id || typeof id == 'object' ? 0 : id;
      this.activeName = 'first';
      this.$openEditView('showEdit');
    },

    editViewDataUpdate() {
      this.editViewDataUpdateFlag = true;
    },
  }
};
</script>
<style lang="scss" >
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}
</style>
